import { useContext } from 'react';

import { FeaturesContext } from 'Context/FeaturesContext/FeaturesContext';

type FeaturesContextType = Record<string, boolean | undefined>;

export type PaymentsFeatureFlags = {
	isPaymentsHideSellerBankDetailsEnabled: boolean;
	isPaymentsMVPEnabled: boolean;
};

/**
 * Hook to get payment-related feature flags.
 *
 * This hook returns the payment feature flags (paymentsMVP, paymentsHideSellerBankDetails)
 * from the FeaturesContext. When PAYMENTS_ONBOARDING_ENABLED=true, these flags are fetched
 * from the payments onboarding service during SSR and merged into the context.
 * When PAYMENTS_ONBOARDING_ENABLED=false (default), they come from LaunchDarkly via
 * the user object.
 *
 * @returns {PaymentsFeatureFlags} Object containing isPaymentsMVPEnabled and isPaymentsHideSellerBankDetailsEnabled flags
 */
export const usePaymentsFeatureFlags = (): PaymentsFeatureFlags => {
	const featuresContext = useContext(FeaturesContext) as FeaturesContextType;

	return {
		isPaymentsHideSellerBankDetailsEnabled: Boolean(featuresContext.paymentsHideSellerBankDetails),
		isPaymentsMVPEnabled: Boolean(featuresContext.paymentsMVP),
	};
};
